import React, { useState } from 'react';
import { ArrowUpRight, ArrowDownLeft, Search, Filter, MoreHorizontal, Check, AlertCircle, Clock, Loader2, CheckCircle2 } from 'lucide-react';
export function ProductPreview() {
  const [pendingStatus, setPendingStatus] = useState<'pending' | 'matching' | 'justMatched' | 'matched'>('pending');
  const handleAutoMatchAll = () => {
    if (pendingStatus !== 'pending') return;
    // Phase 1: Show matching animation
    setPendingStatus('matching');
    // Phase 2: Show "just matched" flash
    setTimeout(() => setPendingStatus('justMatched'), 1200);
    // Phase 3: Settle to matched
    setTimeout(() => setPendingStatus('matched'), 2800);
  };
  return <section className="pb-24 bg-white overflow-hidden" data-id="element-386">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-387">
        <div className="relative mx-auto max-w-5xl" data-id="element-388">
          {/* Decorative background blob */}
          <div className="absolute -top-24 -left-20 w-96 h-96 bg-violet-200 rounded-full blur-3xl opacity-20" data-id="element-389"></div>

          {/* Main Dashboard Card */}
          <div className="relative rounded-xl bg-white shadow-2xl border border-gray-200 overflow-hidden transform rotate-1 hover:rotate-0 transition-transform duration-700 ease-out" data-id="element-390">
            {/* Fake Browser Header */}
            <div className="bg-gray-50 border-b border-gray-200 px-4 py-3 flex items-center gap-2" data-id="element-391">
              <div className="flex gap-1.5" data-id="element-392">
                <div className="w-3 h-3 rounded-full bg-red-400" data-id="element-393"></div>
                <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-394"></div>
                <div className="w-3 h-3 rounded-full bg-green-400" data-id="element-395"></div>
              </div>
              <div className="ml-4 bg-white border border-gray-200 rounded-md px-3 py-1 text-xs text-gray-500 flex-1 max-w-xs flex items-center" data-id="element-396">
                <span className="opacity-50" data-id="element-397">
                  berry.finance/app/reconciliation
                </span>
              </div>
            </div>

            {/* App Header */}
            <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-white" data-id="element-398">
              <div data-id="element-399">
                <h3 className="text-lg font-bold text-gray-900" data-id="element-400">
                  Reconciliation
                </h3>
                <p className="text-sm text-gray-500" data-id="element-401">Last updated: Just now</p>
              </div>
              <div className="flex gap-3" data-id="element-402">
                <button className="p-2 text-gray-400 hover:text-gray-600" data-id="element-403">
                  <Search className="h-5 w-5" data-id="element-404" />
                </button>
                <button className="p-2 text-gray-400 hover:text-gray-600" data-id="element-405">
                  <Filter className="h-5 w-5" data-id="element-406" />
                </button>
                <button onClick={handleAutoMatchAll} className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${pendingStatus === 'matching' ? 'bg-violet-500 text-white' : pendingStatus !== 'pending' ? 'bg-green-600 text-white hover:bg-green-700' : 'bg-violet-600 text-white hover:bg-violet-700'}`} data-id="element-407">

                  {pendingStatus === 'matching' ? <span className="flex items-center gap-2" data-id="element-408">
                      <Loader2 className="h-4 w-4 animate-spin" data-id="element-409" />
                      Matching...
                    </span> : pendingStatus !== 'pending' ? <span className="flex items-center gap-2" data-id="element-410">
                      <Check className="h-4 w-4" data-id="element-411" />
                      All Matched
                    </span> : 'Auto-Match All'}
                </button>
              </div>
            </div>

            {/* Table Content */}
            <div className="bg-white" data-id="element-412">
              <div className="grid grid-cols-12 gap-4 px-6 py-3 border-b border-gray-100 bg-gray-50/50 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-413">
                <div className="col-span-4" data-id="element-414">Transaction</div>
                <div className="col-span-2" data-id="element-415">Date</div>
                <div className="col-span-2 text-right" data-id="element-416">Amount</div>
                <div className="col-span-3" data-id="element-417">Status</div>
                <div className="col-span-1" data-id="element-418"></div>
              </div>

              {/* Row 1: Matched */}
              <div className="grid grid-cols-12 gap-4 px-6 py-4 border-b border-gray-50 items-center hover:bg-gray-50 transition-colors" data-id="element-419">
                <div className="col-span-4 flex items-center gap-3" data-id="element-420">
                  <div className="p-2 bg-green-100 rounded-full" data-id="element-421">
                    <ArrowDownLeft className="h-4 w-4 text-green-600" data-id="element-422" />
                  </div>
                  <div data-id="element-423">
                    <p className="font-medium text-gray-900" data-id="element-424">
                      Stripe Payout #8823
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-425">Incoming Transfer</p>
                  </div>
                </div>
                <div className="col-span-2 text-sm text-gray-600" data-id="element-426">
                  Oct 24, 2025
                </div>
                <div className="col-span-2 text-right text-sm font-medium text-green-600" data-id="element-427">
                  +$4,250.00
                </div>
                <div className="col-span-3" data-id="element-428">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700" data-id="element-429">
                    <Check className="h-3 w-3" data-id="element-430" /> Matched
                  </span>
                </div>
                <div className="col-span-1 text-right" data-id="element-431">
                  <MoreHorizontal className="h-4 w-4 text-gray-400 ml-auto" data-id="element-432" />
                </div>
              </div>

              {/* Row 2: Anomaly */}
              <div className="grid grid-cols-12 gap-4 px-6 py-4 border-b border-gray-50 items-center bg-red-50/30 hover:bg-red-50/50 transition-colors" data-id="element-433">
                <div className="col-span-4 flex items-center gap-3" data-id="element-434">
                  <div className="p-2 bg-red-100 rounded-full" data-id="element-435">
                    <ArrowUpRight className="h-4 w-4 text-red-600" data-id="element-436" />
                  </div>
                  <div data-id="element-437">
                    <p className="font-medium text-gray-900" data-id="element-438">Unknown Vendor</p>
                    <p className="text-xs text-gray-500" data-id="element-439">Card ending 4242</p>
                  </div>
                </div>
                <div className="col-span-2 text-sm text-gray-600" data-id="element-440">
                  Oct 23, 2025
                </div>
                <div className="col-span-2 text-right text-sm font-medium text-gray-900" data-id="element-441">
                  -$129.99
                </div>
                <div className="col-span-3" data-id="element-442">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-red-100 text-red-700" data-id="element-443">
                    <AlertCircle className="h-3 w-3" data-id="element-444" /> Anomaly
                  </span>
                </div>
                <div className="col-span-1 text-right" data-id="element-445">
                  <MoreHorizontal className="h-4 w-4 text-gray-400 ml-auto" data-id="element-446" />
                </div>
              </div>

              {/* Row 3: Pending → Animated Auto-Match */}
              <div className={`grid grid-cols-12 gap-4 px-6 py-4 border-b border-gray-50 items-center transition-all duration-500 ${pendingStatus === 'matching' ? 'bg-violet-100 scale-[1.01] shadow-md ring-2 ring-violet-300' : pendingStatus === 'justMatched' ? 'bg-green-50 ring-2 ring-green-300' : pendingStatus === 'matched' ? 'bg-white hover:bg-gray-50' : 'hover:bg-gray-50'}`} data-id="element-447">

                <div className="col-span-4 flex items-center gap-3" data-id="element-448">
                  <div className={`p-2 rounded-full transition-colors duration-500 ${pendingStatus === 'matching' ? 'bg-violet-200' : pendingStatus === 'justMatched' ? 'bg-green-200' : pendingStatus === 'matched' ? 'bg-green-100' : 'bg-blue-100'}`} data-id="element-449">

                    {pendingStatus === 'matching' ? <Loader2 className="h-4 w-4 text-violet-600 animate-spin" data-id="element-450" /> : pendingStatus === 'justMatched' ? <CheckCircle2 className="h-4 w-4 text-green-600" data-id="element-451" /> : pendingStatus === 'matched' ? <ArrowUpRight className="h-4 w-4 text-green-600" data-id="element-452" /> : <ArrowUpRight className="h-4 w-4 text-blue-600" data-id="element-453" />}
                  </div>
                  <div data-id="element-454">
                    <p className="font-medium text-gray-900" data-id="element-455">
                      AWS Web Services
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-456">Infrastructure</p>
                  </div>
                </div>
                <div className="col-span-2 text-sm text-gray-600" data-id="element-457">
                  Oct 22, 2025
                </div>
                <div className="col-span-2 text-right text-sm font-medium text-gray-900" data-id="element-458">
                  -$842.50
                </div>
                <div className="col-span-3" data-id="element-459">
                  {pendingStatus === 'matching' && <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-violet-100 text-violet-700 animate-pulse" data-id="element-460">
                      <Loader2 className="h-3 w-3 animate-spin" data-id="element-461" /> Matching...
                    </span>}
                  {pendingStatus === 'justMatched' && <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700" data-id="element-462">
                      <CheckCircle2 className="h-3 w-3" data-id="element-463" /> Just Matched!
                    </span>}
                  {pendingStatus === 'matched' && <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700" data-id="element-464">
                      <Check className="h-3 w-3" data-id="element-465" /> Matched
                    </span>}
                  {pendingStatus === 'pending' && <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-700" data-id="element-466">
                      <Clock className="h-3 w-3" data-id="element-467" /> Pending
                    </span>}
                </div>
                <div className="col-span-1 text-right" data-id="element-468">
                  <MoreHorizontal className="h-4 w-4 text-gray-400 ml-auto" data-id="element-469" />
                </div>
              </div>

              {/* Row 4: Matched */}
              <div className="grid grid-cols-12 gap-4 px-6 py-4 border-b border-gray-50 items-center hover:bg-gray-50 transition-colors" data-id="element-470">
                <div className="col-span-4 flex items-center gap-3" data-id="element-471">
                  <div className="p-2 bg-green-100 rounded-full" data-id="element-472">
                    <ArrowDownLeft className="h-4 w-4 text-green-600" data-id="element-473" />
                  </div>
                  <div data-id="element-474">
                    <p className="font-medium text-gray-900" data-id="element-475">
                      Client Invoice #1024
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-476">Direct Deposit</p>
                  </div>
                </div>
                <div className="col-span-2 text-sm text-gray-600" data-id="element-477">
                  Oct 21, 2025
                </div>
                <div className="col-span-2 text-right text-sm font-medium text-green-600" data-id="element-478">
                  +$1,500.00
                </div>
                <div className="col-span-3" data-id="element-479">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700" data-id="element-480">
                    <Check className="h-3 w-3" data-id="element-481" /> Matched
                  </span>
                </div>
                <div className="col-span-1 text-right" data-id="element-482">
                  <MoreHorizontal className="h-4 w-4 text-gray-400 ml-auto" data-id="element-483" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}